<script lang="ts">
    import { unreadMessages } from "./NotificationsService";
</script>

{#if $unreadMessages > 0}
    <span
        class="inline-flex top-0 items-center justify-center w-4 h-4 dir-aware-pl-1 text-xs font-semibold text-blue-800 rounded-full"
    >
        {$unreadMessages}
        <span class="absolute inset-0 animate-ping rounded-full bg-slate-100" />
    </span>
{/if}
